// extracted by mini-css-extract-plugin
export default {"addProductForm":"AddProduct_addProductForm__dB+FV"};